module.exports = __webpack_public_path__ + "img/16l011-06.091d806c.jpg";